export default __webpack_public_path__ + "static/media/2022.c03b8ff2.png";